import PropTypes from 'prop-types';
import React from 'react';
import { getStatusUsingWindow } from '.';
import PhaseType from 'types/phase';

export const complete_repair = ({ phase, event: { kind, data: { next_status } } }) =>
  <div className={kind}>
    Next Status: {getStatusUsingWindow(phase, next_status)}
  </div>;

complete_repair.defaultProps = { phase: null };

complete_repair.propTypes = {
  event: PropTypes.shape({
    user: PropTypes.string.isRequired,
    kind: PropTypes.string.isRequired,
    data: PropTypes.shape({
      next_status: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  phase: PhaseType,
};



// WEBPACK FOOTER //
// ./client/app/shared/components/PhaseHistoryCard/phaseEvents/complete_repair.jsx